import { EntityMenuName, NodeWithName } from '../EntitySelectionPanelUI';
import { MenuItemIcon } from './NodeIcon';
import React, { forwardRef, useCallback } from 'react';
import KubitTooltip from '../../../KubitTooltip';
import { IInlineBranchNode, ISelectableNode } from '../types';
import AnyNode from './AnyNode';
import { getAnyNodeKey, isNodeEqualToEntity } from '../utils';
import { usePanelStateContext } from '../context';
import { FavoriteStarIcon, IconWrapper, SvgIcon } from '../../../Icon';
import useDelayedHover from '../useDelayedHover';

interface IProps {
  indent: number;
  node: IInlineBranchNode;
  onSelectNode: (node: ISelectableNode) => void;
  selectedNode: ISelectableNode;
}

const InlineBranchNode = forwardRef<HTMLDivElement, IProps>(
  ({ node, onSelectNode, selectedNode, indent }, ref) => {
    const {
      toggleInlineBranch,
      getIsExpandedInlineBranch,
      searchTerm,
      selectedEntities,
    } = usePanelStateContext();

    const isExpanded = getIsExpandedInlineBranch(node) || searchTerm !== '';

    const isEntitySelected = selectedEntities.some((entity) =>
      isNodeEqualToEntity(node, entity),
    );

    const selectHandler = useCallback(
      () => onSelectNode(node),
      [node, onSelectNode],
    );

    const { mouseLeaveHandler, mouseEnterHandler } =
      useDelayedHover(selectHandler);

    return (
      <>
        <KubitTooltip content={node.name} placement="bottom-start">
          <NodeWithName
            $selected={false}
            ref={ref}
            $indent={indent}
            onClick={() => toggleInlineBranch(node)}
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
          >
            <MenuItemIcon node={node} />
            <EntityMenuName>{node.name}</EntityMenuName>
            {isEntitySelected && (
              <IconWrapper size={16}>
                <SvgIcon name="circle-check" width={12} height={12} />
              </IconWrapper>
            )}
            {node.isFavorite && <FavoriteStarIcon isActive={true} />}
          </NodeWithName>
        </KubitTooltip>
        {isExpanded &&
          node.children.map((node, i) => (
            <AnyNode
              indent={indent + 1}
              node={node}
              key={getAnyNodeKey(node, i)}
              onSelectNode={onSelectNode}
              selectedNode={selectedNode}
            />
          ))}
      </>
    );
  },
);
export default InlineBranchNode;
